// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_gju","cls2":"CiterightInfoBanner-cls2_PlJ CiterightInfoBanner-cls1_gju"};